import { theme as chakraTheme } from '@chakra-ui/theme';

export const space = {
  ...chakraTheme.space,
  11: '2.75rem',
  13: '3.25rem',
  15: '3.75rem',
  21: '5.25rem',
  21.5: '5.375rem',
  22: '5.5rem',
  22.5: '5.625rem',
  23: '5.75rem',
  27: '6.75rem',
  30: '7.5rem',
  68: '17rem',
  70: '17.5rem',
};
